import type { Guest } from '@interfaces/guest.interface';

import { DOC_TYPES, FIRST_NAMES, KINSHIPS, LAST_NAMES } from '../pools';
import { daysFromNow, pick, randomBool, randomEmail, randomInt, randomPhone } from '../utils';

let _guestSeq = 0;

export function buildGuest(overrides?: Partial<Guest>): Guest {
  const name = pick(FIRST_NAMES);
  const firstLastName = pick(LAST_NAMES);
  return {
    id: ++_guestSeq,
    name,
    firstLastName,
    secondLastName: randomBool(0.4) ? pick(LAST_NAMES) : undefined,
    isMainGuest: false,
    email: randomEmail(name, firstLastName),
    phone: randomPhone(),
    docType: pick(DOC_TYPES),
    docNumber: `${randomInt(10000000, 99999999)}${String.fromCharCode(randomInt(65, 90))}`,
    docSupport: undefined,
    kinship: pick(KINSHIPS),
    birthdate: daysFromNow(-randomInt(6000, 25000)),
    ...overrides,
  };
}

export function buildGuests(count: number): Guest[] {
  const guests = Array.from({ length: count }, () => buildGuest());
  if (guests.length > 0) {
    guests[0].isMainGuest = true;
  }
  return guests;
}
